module.exports = __webpack_public_path__ + "ce79ed11857066ef4f2384938ae805bc.svg";